/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Showcase_BookInputs */

const en_landing_showcase_book = /** @type {(inputs: Landing_Showcase_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magazine cover`)
};

const zh_landing_showcase_book = /** @type {(inputs: Landing_Showcase_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`杂志封面`)
};

/**
* | output |
* | --- |
* | "Magazine cover" |
*
* @param {Landing_Showcase_BookInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_showcase_book = /** @type {((inputs?: Landing_Showcase_BookInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Showcase_BookInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_showcase_book(inputs)
	return zh_landing_showcase_book(inputs)
});
export { landing_showcase_book as "landing.showcase.book" }